import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Trip } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class TripService extends UzurvRestService {
  readonly resourceUrl = 'trips/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * @param searchString
   * @param pageNumber
   * @param pageSize
   * @param unactivatedWillCall
   * @permission trip_search
   */
  searchTrips(searchString: string, pageNumber: number, pageSize: number, nonactivatedWillCall?: boolean): Observable<Array<Trip>> {
    return this.get<Array<Trip>>(`search/${this.resourceUrl}`, {
      searchString: searchString,
      pageNumber: pageNumber,
      pageSize: pageSize,
      nonactivatedWillCall: nonactivatedWillCall
    }).pipe(map(response => Deserialize(response, Trip)));
  }
}
